export const httpMethods = [
    'GET',
    'POST',
    'PUT',
    'DELETE',
    'PATCH',
    'HEAD'
];
//# sourceMappingURL=type.js.map